import { useMemo } from 'react';

import useEnhancedQuery from '@/modules/common/application/use-enhanced-query';
import { GetUsersQuery, User, UserRole } from '@/modules/common/types';
import { GET_USERS } from '@/services/graphql/queries';

import { sortUserArray } from './sort';

export const useUsers = () => {
  const { loading, data, error } = useEnhancedQuery<GetUsersQuery>(GET_USERS, {
    fetchPolicy: 'cache-and-network',
  });

  const sortedUsersWithoutStakeholder =
    data && data.users
      ? sortUserArray(
          data.users?.filter(
            (user) => user.role !== UserRole.STAKEHOLDER && user.role !== UserRole.VIEWER
          )
        )
      : [];

  const admins =
    data && data.users
      ? sortUserArray(data.users?.filter((user) => user.role === UserRole.ADMIN))
      : [];

  const sortedUsers = useMemo(() => {
    return data && data.users
      ? sortUserArray(data.users.filter((user) => user.role !== UserRole.VIEWER))
      : [];
  }, [data]);

  const getSignedUsers = (): User[] | undefined => {
    return sortedUsers.filter((user) => user.status === 'USER_INFO_COMPLETED');
  };

  const getUserById = (userId: string) => {
    return data?.users.find((user) => user.id === userId);
  };

  const internalUsers = useMemo(() => {
    return (
      sortedUsers.filter(
        (user) => user.role === UserRole.ADMIN || user.role === UserRole.EMPLOYEE
      ) || []
    );
  }, [sortedUsers]);

  return {
    users: sortedUsers,
    allUsers: sortUserArray(data?.users || []),
    usersWithoutStakeholder: sortedUsersWithoutStakeholder,
    admins,
    loading,
    error,
    getSignedUsers,
    getUserById,
    internalUsers,
  };
};
